/**
 * 'Dealers.store' Store
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import BaseStore from '@/utils/base-store'

export const options = {}
export default new BaseStore('codes', options)



// WEBPACK FOOTER //
// ./src/store/modules/codes.store.js